import classNames from 'classnames'

import { type IDropItem } from '../helper'

import style from './Item.module.scss'

interface IProps extends IDropItem {}

export const Item = (props: IProps) => {
    const { title, callback, color, dataLocator } = props
    return (
        <div className={classNames(style.container, style[color])}>
            <span data-locator={dataLocator} onMouseDown={callback}>
                {title}
            </span>
        </div>
    )
}
